import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M82.292 20.833a3.126 3.126 0 0 1 3.125 3.125v16.667a3.125 3.125 0 0 1-6.25 0v-9.562L46.903 60.637a3.12 3.12 0 0 1-2.111.825 3.13 3.13 0 0 1-2.112-.825L10.417 31.063v46.02h68.75v-3.125a3.126 3.126 0 0 1 6.25 0v3.125a6.25 6.25 0 0 1-6.25 6.25h-68.75a6.25 6.25 0 0 1-6.25-6.25V23.958a3.125 3.125 0 0 1 3.125-3.125zm-16.5 30.074a2.787 2.787 0 1 1 4.004 3.874l-2.812 2.742c10.624-2.467 22.129 1.523 27.482 8.656.941 1.254.328 2.979-1.103 3.62-1.312.589-2.842.04-3.78-1.049-1.67-1.94-4.16-3.687-7.527-5.037-4.772-1.911-8.46-1.33-15.17-.75l2.515 2.491a2.89 2.89 0 1 1-4.098 4.077l-5.781-5.916a4.17 4.17 0 0 1-.098-5.721zm-21 3.187 29.463-27.011H15.328z" }, null, -1)
  ]))]))
}
export default { render: render }